<div class="error-page" *transloco="let t">
    <div class="cirklo-logo">
        <img width="100" height="100" src="assets/cirklo.svg" alt="Cirklo" />
    </div>

    <h1 class="title mt-5">{{ t('SOMETHING_WENT_WRONG') }}</h1>
    <div class="message mt-5">{{ t('ERROR_CONNECTING_TO_SERVER') }}</div>
    <div class="actions mt-5">
        <a mat-flat-button routerLink="/">{{ t('TRY_AGAIN') }}</a>
    </div>
</div>
